<div style="display: flex; align-items: center">
  <mat-progress-bar class="example-margin" color="primary" [value]="progress" style="flex: 1">
  </mat-progress-bar>
  <div style="min-width: 100px; text-align: right; margin-left: 5px">
    <div>{{ recorded }} / {{ total }} recorded</div>
    <button mat-button routerLink="/summary">View All</button>
  </div>
</div>
